const AUTH_PASSWORD_NAMESPACE = "lovable-pinay-auth-v1";

const toHex = (buffer: ArrayBuffer) =>
  Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, "0")).join("");

export const encodeAuthPassword = async (email: string, password: string) => {
  const normalizedEmail = email.trim().toLowerCase();
  const normalizedPassword = password ?? "";
  const payload = `${AUTH_PASSWORD_NAMESPACE}:${normalizedEmail}:${normalizedPassword}`;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(payload));
  const hex = toHex(digest);

  return `Lp!${hex.slice(0, 16)}A${hex.slice(16, 32)}9#${hex.slice(32, 48)}`;
};

export const shouldRetryRawPassword = (message?: string | null) => {
  const normalized = (message || "").toLowerCase();
  return normalized.includes("invalid login credentials") || normalized.includes("invalid credentials");
};
